// Player squads for different tournaments
export const squadPlayersHimalayan = [
  'Bigyan K',
  'Bishal G',
  'Harjit K',
  'Himal Y',
  'Nel jung G',
  'Niraj K(c)',
  'Prakash A',
  'Ronak T',
  'Sagar U',
  'Sagar N',
  'Shisir P',
  'Sudip P',
  'Swayam S',
  'Tshering Y',
];

export const squadPlayersGurkha = [
  'Bikash P',
  'Bishal G',
  'Harjit K',
  'Himal Y',
  'Mohan G',
  'Nel jung G',
  'Niraj K(c)',
  'Prakash A',
  'Ronak T',
  'Sagar C',
  'Sagar N',
  'Sudip P',
  'Swayam S',
  'Tshering Y',
];

export const squadPlayersGurkhaVeteran = [
  'Bijen',
  'Deepak',
  'Dipesh',
  'Mabin',
  'Rabin',
  'Ritesh',
  'Rupesh(c)',
  'Sabin',
  'Sagar',
  'Subash',
];

// Tournament list
export const tournaments = [
  { name: 'FC Gurkha', year: '2026' },
  { name: 'Himalayan Cup', year: '2026' },
  { name: 'Gaule Cup', year: '2026' },
  { name: 'MAMC', year: '2026' },
];

// Himalayan Cup data
export const himalayanCupData = {
  groupTeams: [
    {
      name: 'Mirmire SC',
      logo: '/mirmire_logo_no_background.png',
      isExternal: false,
    },
    {
      name: 'Manse Nepal',
      logo: '/gallery/manse.jpg',
      isExternal: false,
    },
    {
      name: 'Himalayan SC Red',
      logo: 'https://himalayansportsclub.com/static/media/logo.f7918ca5090e7302063fb164041328bd.svg',
      isExternal: true,
    },
    {
      name: 'Fishtail SC',
      logo: '/gallery/fsc.jpg',
      isExternal: false,
    },
  ],
  fixtures: [
    {
      time: '10:20 - 10:50',
      field: 'Field 1',
      team1: 'Himalayan SC Red',
      team2: 'Mirmire SC',
      team1Logo:
        'https://himalayansportsclub.com/static/media/logo.f7918ca5090e7302063fb164041328bd.svg',
      team2Logo: '/mirmire_logo_no_background.png',
      isOurMatch: true,
      matchType: 'GROUP STAGE',
      importance: 'Tournament Opener',
      matchNumber: 1,
    },
    {
      time: '12:20 - 12:50',
      field: 'Field 2',
      team1: 'Mirmire SC',
      team2: 'Fishtail SC',
      team1Logo: '/mirmire_logo_no_background.png',
      team2Logo: '/gallery/fsc.jpg',
      isOurMatch: true,
      matchType: 'GROUP STAGE',
      importance: 'Crucial Match',
      matchNumber: 2,
    },
    {
      time: '14:20 - 14:50',
      field: 'Field 2',
      team1: 'Mirmire SC',
      team2: 'Manse Nepal',
      team1Logo: '/mirmire_logo_no_background.png',
      team2Logo: '/gallery/manse.jpg',
      isOurMatch: true,
      matchType: 'GROUP STAGE',
      importance: 'Final Group Match',
      matchNumber: 3,
    },
  ],
  tournamentDate: 'June 14th, 2025',
  tournamentName: 'Himalayan Cup Football Tournament 2025',
};
